import { storeManager } from '../../../../core/store/store-manager.ts';

export function broadcastCookieUpdateToIframes(options?: { closeModal?: boolean }) {
  const sid = storeManager.getCookie('SIZEBAY_SESSION_ID_V4');
  const personaHash = storeManager.getCookie('SIZEBAY_PERSONA_HASH');

  const message: { id: 'szb_cookies_update'; sid: string; personaHash: string } = {
    id: 'szb_cookies_update',
    sid,
    personaHash,
  };

  const similarIframe = document.getElementById('fashion-hint-iframe-similar') as HTMLIFrameElement | null;
  const complementaryIframe = document.getElementById('fashion-hint-iframe-complementary') as HTMLIFrameElement | null;

  const drawerIframe = document.getElementById('fashion-hint-iframe-drawer') as HTMLIFrameElement | null;

  if (similarIframe?.contentWindow) {
    similarIframe.contentWindow.postMessage(message, '*');
    similarIframe.contentWindow.postMessage({ id: 'szb_recommendation_ready' }, '*');
  }

  if (complementaryIframe?.contentWindow) {
      complementaryIframe.contentWindow.postMessage(message, '*');
      complementaryIframe.contentWindow.postMessage({ id: 'szb_recommendation_ready' }, '*');
  }

  if (options?.closeModal && drawerIframe?.contentWindow) {
    const closeMessage: { id: 'szb_close_form' } = { id: 'szb_close_form' };
    drawerIframe.contentWindow.postMessage(closeMessage, '*');
  }
}
